import React from "react";
import times from "lodash/times";
import { withTranslation } from "react-i18next";
import Modal from "../modal";
import GroupCheckbox from "../inputs/group-checkbox";
import { RillContext } from "../../rill/RillReact/share/base";

class EditProgramSettingsModal extends React.Component {
  constructor(props, ctx) {
    super(props, ctx);

    const {
      locals: { query, activeUser, editCycle },
    } = ctx;
    this.program = editCycle.programs[query.program - 1];
    query.liftPriority = this.program.liftPriority;

    this.state = {
      maxFrequency: editCycle.programs[query.program - 1].sessionsPerWeek || 7,
      query,
    };
    this.handleLiftFrequencyChange = this.handleLiftFrequencyChange.bind(this);
    this.liftFrequencyOptions = this.liftFrequencyOptions.bind(this);
  }

  handleLiftFrequencyChange({ target: { value } }) {
    if (this.state.maxFrequency == value || parseInt(value) < 1) return;
    this.setState({ maxFrequency: value });
  }

  liftFrequencyOptions(maxFrequency) {
    // Number of lift frequency options is the same as the number of sessions per week
    return times(parseInt(maxFrequency) + 1, (ind) => (
      <option key={ind}>{ind}</option>
    ));
  }

  UNSAFE_componentWillReceiveProps() {
    const {
      locals: { query },
    } = this.context;
    this.setState({ query });
  }

  render() {
    const { t } = this.props;
    const {
      locals: { activeUser, editCycle, athlete },
    } = this.context;
    const query = this.state.query;
    const program = editCycle.programs[query.program - 1];
    const isCoach = ["coach", "coachCanSubmit", "admin"].some((role) =>
      activeUser.hasRole(role)
    );

    return (
      <form
        action={`/actions/cycle/edit/program/${
          query.cycleId || query.cycle || editCycle._id
        }?program=${query.program}&athlete=${athlete ? athlete._id : ""}`}
        method="POST"
        data-noreset
      >
        <Modal toClear="liftPriority">
          <div className="head">
            <h2 className="alt">{t("editProgramSettings.title")}</h2>
          </div>

          <div className="body">
            <div className="Program-Settings">
              <div className="group">
                <div className="label req">
                  {t("editProgramSettings.programName")}
                </div>
                <input
                  name="name"
                  className="text-input"
                  defaultValue={program.name}
                  placeholder={t("editProgramSettings.programNamePlaceholder")}
                />
              </div>

              <div className="group">
                <div className="label">{t("editProgramSettings.goals")}</div>
                <input
                  name="goals"
                  className="text-input"
                  defaultValue={program.goals}
                />
              </div>

              {isCoach && (
                <div className="group">
                  <div className="label">
                    {t("editProgramSettings.difficulty")}
                  </div>
                  <ul className="Radio-Group Difficulty-Group" data-cols="1/3">
                    <li>
                      <label className="radio-input">
                        <input
                          name="difficulty"
                          type="radio"
                          value="Novice"
                          defaultChecked={program.difficulty === "Novice"}
                        />
                        <span className="radio" />
                        <span className="text">
                          {t("editProgramSettings.novice")}
                        </span>
                      </label>
                    </li>
                    <li>
                      <label className="radio-input">
                        <input
                          name="difficulty"
                          type="radio"
                          value="Intermediate"
                          defaultChecked={program.difficulty === "Intermediate"}
                        />
                        <span className="radio" />
                        <span className="text">
                          {t("editProgramSettings.intermediate")}
                        </span>
                      </label>
                    </li>
                    <li>
                      <label className="radio-input">
                        <input
                          name="difficulty"
                          type="radio"
                          value="Advanced"
                          defaultChecked={program.difficulty === "Advanced"}
                        />
                        <span className="radio" />
                        <span className="text">
                          {t("editProgramSettings.advanced")}
                        </span>
                      </label>
                    </li>
                  </ul>
                </div>
              )}

              {isCoach && (
                <GroupCheckbox
                  name="liftPriority"
                  title={t("editProgramSettings.liftPriority")}
                  propQuery={query}
                  checkboxes={[
                    { html: t("editProgramSettings.squat"), value: "Squat" },
                    { html: t("editProgramSettings.bench"), value: "Bench" },
                    { html: t("editProgramSettings.deadlift"), value: "Deadlift" },
                  ]}
                  inputGroupClassName="Check-Group"
                />
              )}

              {/*isCoach && <div className="group">
									<div className="label">Lift Priority</div>
									<ul className="Radio-Group" data-cols="1/3">
										<li>
											<label className="radio-input">
												<input name="liftPriority" type="radio" value="Squat" defaultChecked={program.liftPriority.includes("Squat")}/>
												<span className="radio"></span>
												<span className="text"><b className="squat">Squat</b></span>
											</label>
										</li>
										<li>
											<label className="radio-input">
												<input name="liftPriority" type="radio" value="Bench" defaultChecked={program.liftPriority.includes("Bench")}/>
												<span className="radio"></span>
												<span className="text"><b className="bench">Bench</b></span>
											</label>
										</li>
										<li>
											<label className="radio-input">
												<input name="liftPriority" type="radio" value="Deadlift" defaultChecked={program.liftPriority.includes("Deadlift")}/>
												<span className="radio"></span>
												<span className="text"><b className="deadlift">Deadlift</b></span>
											</label>
										</li>
									</ul>
								</div>*/}

              {isCoach && (
                <div className="group">
                  <div className="columns">
                    <div className="column" data-col="1/3">
                      <div className="label">
                        {t("editProgramSettings.squatFrequency")}
                      </div>
                      <select
                        name="squatFrequency"
                        className="select-input"
                        defaultValue={program.squatFrequency}
                      >
                        <option></option>
                        {this.liftFrequencyOptions(this.state.maxFrequency)}
                      </select>
                    </div>
                    <div className="column" data-col="1/3">
                      <div className="label">
                        {t("editProgramSettings.benchFrequency")}
                      </div>
                      <select
                        name="benchFrequency"
                        className="select-input"
                        defaultValue={program.benchFrequency}
                      >
                        <option></option>
                        {this.liftFrequencyOptions(this.state.maxFrequency)}
                      </select>
                    </div>
                    <div className="column" data-col="1/3">
                      <div className="label">
                        {t("editProgramSettings.deadliftFrequency")}
                      </div>
                      <select
                        name="deadliftFrequency"
                        className="select-input"
                        defaultValue={program.deadliftFrequency}
                      >
                        <option></option>
                        {this.liftFrequencyOptions(this.state.maxFrequency)}
                      </select>
                    </div>
                  </div>
                </div>
              )}

              {isCoach && (
                <div className="group">
                  <div className="columns">
                    <div className="column" data-col="1/3">
                      <div className="label">
                        {t("editProgramSettings.volume")}
                      </div>
                      <select
                        name="volume"
                        className="select-input"
                        defaultValue={program.volume}
                      >
                        <option value="">
                          {t("editProgramSettings.chooseVolume")}
                        </option>
                        <option value="High">
                          {t("editProgramSettings.high")}
                        </option>
                        <option value="Medium">
                          {t("editProgramSettings.medium")}
                        </option>
                        <option value="Low">
                          {t("editProgramSettings.low")}
                        </option>
                      </select>
                    </div>

                    <div className="column" data-col="1/3">
                      <div className="label">
                        {t("editProgramSettings.intensity")}
                      </div>
                      <select
                        name="intensity"
                        className="select-input"
                        defaultValue={program.intensity}
                      >
                        <option value="">
                          {t("editProgramSettings.chooseIntensity")}
                        </option>
                        <option value="High">
                          {t("editProgramSettings.high")}
                        </option>
                        <option value="Medium">
                          {t("editProgramSettings.medium")}
                        </option>
                        <option value="Low">
                          {t("editProgramSettings.low")}
                        </option>
                      </select>
                    </div>

                    <div className="column" data-col="1/3">
                      <div className="label">
                        {t("editProgramSettings.weeksOutFromCompetition")}
                      </div>
                      <select
                        name="weeksToCompetition"
                        className="select-input"
                        defaultValue={program.weeksToCompetition}
                      >
                        <option value="">
                          {t("editProgramSettings.chooseWeeks")}
                        </option>
                        <option value="four">
                          {t("editProgramSettings.fourWeeks")}
                        </option>
                        <option value="eight">
                          {t("editProgramSettings.eightWeeks")}
                        </option>
                        <option value="twelve">
                          {t("editProgramSettings.twelveWeeks")}
                        </option>
                        <option value="more">
                          {t("editProgramSettings.moreThanTwelveWeeks")}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              )}

              {isCoach && (
                <div className="group">
                  <div className="columns">
                    <div className="column" data-col="1/3">
                      <div className="label">
                        {t("editProgramSettings.equippedLifting")}
                      </div>
                      <ul className="Radio-Group" data-cols="1/2">
                        <li>
                          <label className="radio-input">
                            <input
                              name="isEquippedLifting"
                              type="radio"
                              value="true"
                              defaultChecked={program.isEquippedLifting}
                            />
                            <span className="radio"></span>
                            <span className="text">{t("common:yes")}</span>
                          </label>
                        </li>
                        <li>
                          <label className="radio-input">
                            <input
                              name="isEquippedLifting"
                              type="radio"
                              value="false"
                              defaultChecked={!program.isEquippedLifting}
                            />
                            <span className="radio"></span>
                            <span className="text">{t("common:no")}</span>
                          </label>
                        </li>
                      </ul>
                    </div>

                    <div className="column" data-col="2/3">
                      <div className="label">
                        {t("editProgramSettings.equipmentRequired")}
                      </div>
                      <select
                        name="equipmentRequired"
                        className="select-input"
                        defaultValue={program.equipmentRequired}
                      >
                        <option value="">
                          {t("editProgramSettings.chooseEquipment")}
                        </option>
                        <option value="Barbell Only">
                          {t("editProgramSettings.barbellOnly")}
                        </option>
                        <option value="Barbell / Dumbbells">
                          {t("editProgramSettings.barbellDumbbells")}
                        </option>
                        <option value="Barbell / Dumbbells / Cables">
                          {t("editProgramSettings.barbellDumbbellsCables")}
                        </option>
                        <option value="Full Gym Capability">
                          {t("editProgramSettings.fullGymCapability")}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              )}
              <div className="group">
                <div className="label">
                  {isCoach
                    ? t("editProgramSettings.description")
                    : t("editProgramSettings.notes")}
                </div>
                <textarea
                  name="description"
                  className="textarea-input"
                  defaultValue={program.description}
                ></textarea>
              </div>
            </div>
          </div>

          <div className="foot">
            <div className="columns">
              <div className="column" data-col="1/3">
                <a className="button alt" href="/actions/refresh?modal=">
                  {t("common:cancel")}
                </a>
              </div>

              <div
                className="column"
                data-col="1/3"
                style={{ textAlign: "center" }}
              ></div>

              <div
                className="column mobile-hidden"
                data-col="1/3"
                style={{ textAlign: "right" }}
              >
                <button type="submit" className="button-input">
                  {t("common:save")}
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </form>
    );
  }
}

EditProgramSettingsModal.contextType = RillContext;

export default withTranslation("coaching-portal")(EditProgramSettingsModal);
